/* eslint-disable no-shadow */
import Vue from 'vue';
import feathersClient from '../../feathers-client';

export default {
	namespaced: true,
	state: {
		location: null,
		role: null,
		band: null,
		area: null,
		carespecial: null,
		fulfilment: null,
		budgetCode: null,
		shift: null,
		duration: null,
		discreateDates: [],
		shiftTimes: null,
		skills: [],
		primaryValidationData: null,
		jobTemplates: [],
		selectedTemplate: null,
		fullSkills: [],
		jobTitleTypes: [],
		bandTypes: [],
		skillResults: [],
		looseSkills: [],
		createdJobIds: [],
		loadingTemplates: false,
		comment: '',
		selectedJobId: null,
		selectedJobSkills: [],
		favouriteSkills: [],
		shiftProvisionList: [],
		bandTypesByIds:[],
		newSelectedJob:null,
		newJobComment:'',
		selectedShiftsDays:[],
		healthRosterShiftId:'',
		rootReference:null,
		staffPersonas: [],
		selectedPersona: [],
		capabilities: [],
		customPersona: [],
		savedPersona: [],
		teachPersona: [],
		addNewPersona: false,
		isCapabilityFromNewPersona: false,
		staffSkillFrom: '',
		isLoadingPersonas: false,
		isEditJobPersona: false,
		editJobPersonaData: [],
		isEditJobId: null,
		jobRecord: [],
		shiftEditPersona: [],
		latestOgPersona: [],
		showLiveScoreSkillset: false,
		liveScorePersonaId: null,
		personaStaffs: [],
	},
	getters: {
		getSummaryData: (state) => {
			const {
				location, role, band, area, fulfilment, budgetCode, shift, duration, shiftTimes, skills, carespecial,discreateDates, healthRosterShiftId,comment
			} = state;
			return {
				location,
				role,
				band,
				area,
				fulfilment,
				budgetCode,
				shift,
				duration,
				shiftTimes,
				skills,
				carespecial,
				discreateDates,
				healthRosterShiftId,
				comment
			};
		},
		getEditSummaryData: (state) => {
			const {
				location, role, band, area, fulfilment, budgetCode, shift, duration, shiftTimes, skills, comment, carespecial,discreateDates, healthRosterShiftId
			} = state;
			return {
				location,
				role,
				band,
				area,
				fulfilment,
				budgetCode,
				shift,
				duration,
				shiftTimes,
				skills,
				comment,
				carespecial,
				discreateDates,
				healthRosterShiftId,
			};
		},
		getPrimaryValidationData: (state) => state.primaryValidationData,
		staffPersonas: (state) => state.staffPersonas,
		selectedPersona: (state) => state.selectedPersona,
		customPersona: (state) => state.customPersona,
		savedPersona: (state) => state.savedPersona,
		teachPersona: (state) => state.teachPersona,
		editJobPersonaData: (state) => state.editJobPersonaData,
		shiftEditPersona: (state) => state.shiftEditPersona,
		latestOgPersona: (state) => state.latestOgPersona,
		personaStaffs: (state) => state.personaStaffs,

	},
	mutations: {
		SET_ROOT_REFERENCE: (state, payload) => {state.rootReference = payload},
		SET_SELECTED_DAYS: (state, data) => {
			state.selectedShiftsDays = data;
		},
		SET_NEW_JOB_COMMENT: (state, payload) => {
			state.newJobComment = payload;
		},
		SET_NEW_JOB_DATA: (state, payload) => {
			state.newSelectedJob = payload;
		},
		SET_JOB_POSTING_DATA: (state, payload) => {
			state.carespecial = payload.carespecial;
			state.location = payload.location;
			state.role = payload.role;
			state.band = payload.band;
			state.area = payload.area;
			state.fulfilment = payload.fulfilment;
			state.budgetCode = payload.budgetCode;
			state.shift = payload.shift;
			state.duration = payload.duration;
			state.shiftTimes = payload.shiftTimes;
			state.discreateDates = payload.discreateDates;
			state.healthRosterShiftId = payload.healthRosterShiftId;
			state.comment = payload.comment
		},
		SET_JOB_SKILLS_FILTER_DATA: (state, payload) => {
			state.location = payload.location;
			state.role = payload.role;
			state.band = payload.band;
			state.area = payload.area;
			state.fulfilment = payload.fulfilment;
			state.shift = payload.shift;
			state.comment = payload.comment;
			state.duration = payload.duration;
			state.createdJobIds = payload.jobIds;
			state.carespecial = payload.carespecial
			state.healthRosterShiftId = payload.healthRosterShiftId;
		},
		SET_PRIMARY_VALIDATION_DATA: (state, payload) => {
			state.primaryValidationData = payload;
		},
		SET_TEMPLATE_MAPPINGS: (state, payload) => {
			state.jobTemplates = payload;
		},
		SET_SELECTED_TEMPLATE: (state, payload) => {
			state.selectedTemplate = payload;
		},
		SET_SELECTED_JOBID: (state, payload) => {
			state.selectedJobId = payload;
		},
		SET_BAND_TYPES: (state, payload) => {
			state.bandTypes = payload;
		},
		SET_BAND_TYPES_BY_ID: (state, payload) => {
			state.bandTypesByIds = payload;
		},
		SET_JOB_TITLE_TYPES: (state, payload) => {
			state.jobTitleTypes = payload;
		},
		SET_SELECTED_JOB_SKILLS: (state, payload) => {
			state.selectedJobSkills = payload;
		},
		SET_SKILL_RESULTS: (state, payload) => {
			state.skillResults = payload;
		},
		ADD_TO_LOOSE_SKILLS: (state, payload) => {
			state.looseSkills.push(payload);
		},
		ADD_SHIFT_PROVISIONS: (state, payload) => {
			state.shiftProvisionList = payload;
		},
		REMOVE_FROM_LOOSE_SKILLS: (state, index) => {
			state.looseSkills.splice(index, 1);
		},
		REFRESH_TEMPLATE_SKILLS: (state) => {
			state.selectedTemplate?.jobTemplateSkills.splice();
		},
		SET_POSTED_JOBS: (state, payload) => {
			state.createdJobIds = payload;
		},
		SET_LOADING_TEMPLATES: (state, payload) => {
			state.loadingTemplates = payload;
		},
		CLEAR_STORE: (state) => {
			state.location = null;
			state.role = null;
			state.band = null;
			state.area = null;
			state.fulfilment = null;
			state.budgetCode = null;
			state.shift = null;
			state.duration = null;
			state.shiftTimes = null;
			state.skills = [];
			state.primaryValidationData = null;
			state.jobTemplates = [];
			state.selectedTemplate = null;
			state.fullSkills = [];
			state.jobTitleTypes = [];
			state.bandTypes = [];
			state.skillResults = [];
			state.looseSkills = [];
			state.createdJobIds = [];
			state.loadingTemplates = false;
			state.selectedJobId = null;
			state.shiftProvisionList = [];
			state.bandTypesByIds=[];
			state.healthRosterShiftId = '';
			state.comment='';
		},
		SET_FAVOURITE_SKILLS: (state, data) => { state.favouriteSkills = data; },
		SET_STAFF_PERSONAS: (state, staffPersonas) => { state.staffPersonas = staffPersonas; },
		SET_SELECTED_PERSONA: (state, selectedPersona) => { state.selectedPersona = selectedPersona; },
		SET_CAPABILITIES: (state, capabilities) => { state.capabilities = capabilities; },
		SET_CUSTOM_PERSONA: (state, customPersona) => { state.customPersona = customPersona; },
		SET_SAVED_PERSONA: (state, savedPersona) => { state.savedPersona = savedPersona; },
		SET_TEACH_PERSONA: (state, teachPersona) => { state.teachPersona = teachPersona; },
		SET_ADD_NEW_PERSONA: (state, payload) => {
			state.addNewPersona = payload;
		},
		SET_IS_CAP_FROM_NEW_PERSONA: (state, payload) => {
			state.isCapabilityFromNewPersona = payload;
		},
		SET_STAFF_SKILL_FROM: (state, staffSkillFrom) => {
			state.staffSkillFrom = staffSkillFrom;
		},
		SET_IS_LOADING_PERSONAS: (state, payload) => {
			state.isLoadingPersonas = payload;
		}, 
		SET_IS_EDIT_JOB_PERSONAS: (state, payload) => {
			state.isEditJobPersona = payload;
		},
		SET_IS_EDIT_JOB_ID: (state, payload) => {
			state.isEditJobId = payload;
		},
		SET_EDIT_JOB_PERSONAS_DATA: (state, editJobPersonaData) => { state.editJobPersonaData = editJobPersonaData; },
		SET_JOB_RECORD: (state, jobRecord) => { state.jobRecord = jobRecord; },
		SET_SHIFT_EDIT_PERSONA: (state, shiftEditPersona) => { state.shiftEditPersona = shiftEditPersona; },
		SET_LATESTOG_PERSONA: (state, latestOgPersona) => { state.latestOgPersona = latestOgPersona; },
		SET_SHOW_LIVE_SCORE_SKILLSET: (state, payload) => {
			state.showLiveScoreSkillset = payload;
		},
		SET_LIVE_SCORE_PERSONA_ID: (state, payload) => {
			state.liveScorePersonaId = payload;
		},
		SET_PERSONA_STAFF: (state, personaStaffs) => { state.personaStaffs = personaStaffs; },
	},
	actions: {
		loadJobTitleByName: async ({ commit, rootGetters }, title) => {
			// const url = `/api/v2/job-titles?filter=${encodeURIComponent(JSON.stringify(filter))}`;
			const results = await feathersClient.service('/api/v3/job-title-types').find({
				query: {
					// $role:rootGetters.currentUserRole,
					name: title,
					$paginate: false,
				},
			});
			return results;
		},
		loadJobTempleteForSelectedJob: async({ commit, state, rootGetters }, id) => {
			const jobTemplateResult = await feathersClient.service('api/v3/jobtemplates').find({
				query: {
					_id: id,
				  $role: rootGetters.currentUserRole,
				  fields: ['baseStaffPersona'],
				  $paginate: false,
				},
			  });
			  if (jobTemplateResult && jobTemplateResult.length > 0) {
				if (jobTemplateResult[0]?.jobTemplateSkills.length > 0) {
					for (let i = 0; i < jobTemplateResult[0].jobTemplateSkills.length; i++) {
						jobTemplateResult[0].jobTemplateSkills[i].selected = 'selected';
					}
				}
				commit('SET_SELECTED_TEMPLATE', jobTemplateResult[0]);
			  } else {
				commit('SET_SELECTED_TEMPLATE', null);
			  }
		},
		loadJobTemplateMappings: async ({ commit, state,rootGetters }) => {
			if(state.band?.length == 0){
				return
			}
			const upperBand = (state.band && state.band.length > 1) ? state.band[1].number : state.band[0].number;
			const lowerBand = state.band[0].number;
			commit('SET_LOADING_TEMPLATES', true);
			commit('SET_TEMPLATE_MAPPINGS', []);
			const query = {
				lowerBand: {$lte : Number(lowerBand)},
				upperBand: {$gte : Number(upperBand ? upperBand : lowerBand)},
				$role:rootGetters.currentUserRole,
				fields:["jobTemplatesMapping","skills"],
				$paginate:false
			  };
			  if (state.role && state.role.length > 0) {
				query.jobTitleTypeId = state.role[0].id;
			  }
			  if (state.area && state.area.length > 0) {
				query.careLocationId = state.area[0].id;
			  }
			  if (state.carespecial && state.carespecial.length > 0) {
				query.careSpecialityTypeId = state.carespecial[0].id;
			  }
			const results = await feathersClient.service('api/v3/jobtemplatemappings').find({
				query: query,
			  });

			const templateMappings = results.map((mapping) => (mapping.jobTemplateJobTemplateMappings ? mapping.jobTemplateJobTemplateMappings : []));
			let merged = [];
			templateMappings.map((item) => merged = [...merged, ...item]);
			const flatTemplates = merged.map((item) => {
				const jobTemplate = item.jobTemplate;
				jobTemplate.isDefault = item.isDefault;
				return jobTemplate;
			});
			let duplicatesFiltered = flatTemplates.filter((value, index, self) => index === self.findIndex((item) => item.id === value.id));
			if (duplicatesFiltered.length === 0 && state.selectedJobId !== null) {
				const jobResult = await feathersClient.service('/api/v3/jobs').get(state.selectedJobId, {
					query: {
						$role: rootGetters.currentUserRole,
					},
				});

				const templateResult = await feathersClient.service('api/v3/jobtemplates').find({
					query: {
				  _id: jobResult.jobTemplateId,
				  $role: rootGetters.currentUserRole,
				  fields: ['jobTemplateSkills'],
				  $paginate: false,
					},
			  });

				duplicatesFiltered = templateResult;
			}
			
			commit('SET_TEMPLATE_MAPPINGS', duplicatesFiltered);
			commit('SET_LOADING_TEMPLATES', false);
		},
		loadBandTypes: async({ commit }) => {
			const results = await feathersClient.service('/api/v3/band-types').find({
				query: {
					$sort: { number: 1 },
					$paginate: false,
				},
			});
			commit('SET_BAND_TYPES', results);
		},
		loadBandMappingById: async({ commit, rootGetters }, ids) => {
			const results = await feathersClient.service('/api/v3/band-mapping-for-jobtitles').find({
				query: {
					$role: rootGetters.currentUserRole,
					jobTitleTypeId: ids,
				},
			});

			// commit('SET_BAND_TYPES_BY_ID', results);
			return results;
		},
		loadBandTypesByIds: async({ commit, rootGetters }, ids) => {
			const results = await feathersClient.service('/api/v3/band-types').find({
				query: {
					_id: { $in: ids },
					$paginate: false,
				},
			});

			return results;
		},
		loadJobTitleTypes: async({ commit }, filter) => {
			const results = await feathersClient.service('/api/v3/job-title-types').find({
				query: {
					// $role: rootGetters.currentUserRole,
					...filter,
					$paginate: false,
				},
			});
			commit('SET_JOB_TITLE_TYPES', results);
		},
		loadMangerShiftProvisions: async({ rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/getincentiveprovisions').find({
				query: {
					$role: rootGetters.currentUserRole,
					$skip: 0,
					$limit: 10,
					...filter,
				},
			});
			return results.data;
		},
		loadJobSkills: async({ commit, rootGetters }, jobId) => {
			const filter = {
				jobId: jobId,
				fields: [],
				$paginate: false,
			};
			const results = await feathersClient.service('/api/v3/job-skills').find({
				query: filter,
			});

			commit('SET_SELECTED_JOB_SKILLS', results.data);
			return results.data;
		},
		searchSkills: async({ commit, rootGetters }, searchString) => {
			const url = '/api/v3/skills';
			const results = await feathersClient.service('/api/v3/skills').find({
				query: {
					$role: rootGetters.currentUserRole,
					$search: searchString,
					$paginate: false,
				},
			});
			commit('SET_SKILL_RESULTS', results);
			return results;
		},
		createJobSkills: async({ commit, state }) => {
			if (state.selectedJobId !== null) {
				const deleteSkills = state.selectedTemplate?.jobTemplateSkills?.filter((item) => item.selected === false);
				deleteSkills.map((a) => {
					const query = {
						jobId: state.selectedJobId,
						skillId: a.skillId,
					};
			 });
			}
			if (state.selectedTemplate && state.selectedTemplate?.jobTemplateSkills && state.selectedTemplate?.jobTemplateSkills.length > 0) {
				const templateSkills = state.selectedTemplate?.jobTemplateSkills?.filter((item) => item.selected === 'selected');
				const cleanedTemplateSkills = templateSkills?.map((item) => ({ requirement: item.requirement, learningOpportunity: item.learningOpportunity, skillId: item.skill.id }));
				const totalSkills = cleanedTemplateSkills?.concat(state.looseSkills.map((item) => ({ requirement: item.requirement, learningOpportunity: item.learningOpportunity, skillId: item.skill.id })));
				const allJobSkills = [];
				// eslint-disable-next-line no-plusplus
				for (let j = 0; j < totalSkills?.length; j++) {
					const fullSkill = totalSkills[j];
					allJobSkills.push({
						requirement: fullSkill.requirement,
						learningOpportunity: fullSkill.learningOpportunity,
						skillId: fullSkill.skillId,
					});
				}
				const filteredDuplicates = allJobSkills?.filter((value, index, self) => index === self.findIndex((item) => item.skillId === value.skillId));
				return filteredDuplicates;
			}
		},
		addJobSkills: async({ rootGetters, dispatch, state }) => {
			const url = '/api/v3/job-skills';
			const skills = await dispatch('createJobSkills');
			const jobSkills = skills?.map((item) => {
				const jobSkill = item;
				jobSkill.jobId = state.selectedJobId;
				return jobSkill;
			});
			await feathersClient.service(url).create(jobSkills, { query: { $role: rootGetters.currentUserRole } });
		},
		updateJobComments: async ({ rootGetters }, data) => {
			const url = `/api/v3/jobs`;
			const results = await feathersClient.service(url).patch(data.id, data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		updateJobTitle: async ({ rootGetters }, data) => {
			const url = `/api/v3/jobs`;
			const results = await feathersClient.service(url).patch(data.id, data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},

		updateShiftStatus: async ({ rootGetters }, data) => {
			const id = data.id;
			delete data.id;
			const url = `/api/v3/jobs`;
			const results = await feathersClient.service(url).patch(id, data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		updateJobVacancies: async ({ rootGetters }, data) => {
			const url = `/api/v3/jobs`;
			const results = await feathersClient.service(url).patch(data.id, data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		deleteJobSkills: async ({ commit, rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/job-skills').remove(null, {
				query: {
					$role: rootGetters.currentUserRole,
					...filter,
					$paginate: false,
				},
			});
			return results;
		},
		updateJobsWithTemplate: async({ rootGetters, state }) => {
			if (state.selectedTemplate) {
				for (let i = 0; i < state.createdJobIds.length; i++) {
					const jobId = state.createdJobIds[i];
					const url = `/api/v3/jobs`;
					await feathersClient.service(url).patch(jobId, { jobTemplateId: state.selectedTemplate.id }, { params: { $role: rootGetters.currentUserRole } });
				}
			}
		},
		getcarelocations: async ({ rootGetters }, filter) => {
			const url = '/api/v3/user-roles'; // SHIFT-MANAGER
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $getCareLocations: true } });
			return results;
		},
		getendorsementskillshistory: async ({ commit, state }, filter) => {
			const url = '/api/v3/endorsement-requests';
			const results = await feathersClient.service(url).find({
				query:
					{ fields: ['endorsementRequestSkills'], ...filter },
			});
			return results;
		},
		getskilldetails: async ({ commit, state }, filter) => {
			const url = '/api/v3/user-skills';
			const results = await feathersClient.service(url).find({
				query:
					{ fields: ['endorsementRequestHistory'], $paginate: false, ...filter },
			});
			return results;
		},

		getendorsereq: async ({ commit, state }, filter) => {
			const url = '/api/v3/endorsement-requests';
			const results = await feathersClient.service(url).find({
				query:
					{ fields: ['endorsementRequestHistory'], ...filter },
			});
			return results;
		},
		getFavouriteSkills: async ({ commit, rootGetters }) => {
			const results = await feathersClient.service('/api/v3/managers-favourite-skills').find({
				query: {
					fields: ['skill'],
					$role: rootGetters.currentUserRole,
				},
			});
			commit('SET_FAVOURITE_SKILLS', results.data);
			return results.data;
		},
		createFavouriteSkills: async ({ commit, rootGetters }, data) => {
			const results = await feathersClient.service('/api/v3/managers-favourite-skills').create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
		},
		deleteFavouriteSkills: async ({ commit, rootGetters }, id) => {
			const results = await feathersClient.service('/api/v3/managers-favourite-skills').remove(id, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
		},
		loadJob: async ({ rootGetters, commit }, id) => {
			const url = `/api/v3/jobs/`; // SHIFT-MANAGER
			const results = await feathersClient.service(url).get(id,{
				query: {
					$role: rootGetters.currentUserRole, fields: ['shiftincentives', 'careLocations'],
				},
			});
			return results;
		},
		addProvisions: async ({ rootGetters }, data) => {
			const url = '/api/v3/add-provisions-to-job';
			const results = await feathersClient.service(url).create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		getCarelocations: async ({ rootGetters }, searchString) => {
			const url = '/api/v3/user-roles';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $getCareLocationsOfRole: true, $search: searchString } });
			
			return results;
		},
		getDraftedShiftChecklistItem: async({rootGetters}) => {
			const url = '/api/v3/drafted-shift-checklist-configuration';
			const results = await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole,
					$paginate:false
				 	}
			});
			return results;
		},
		searchStaffPersonas: async ({ rootGetters, commit }, filter) => {
			const url = '/api/v3/personas';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $forJobPosting: true, $paginate: false, ...filter } });
			commit('SET_STAFF_PERSONAS', results);
			return results;
		},
		defaultPersonas: async ({ rootGetters, commit }, filter) => {
			commit('SET_LOADING_TEMPLATES', true);
			const url = '/api/v3/persona-mappings';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $forJobPosting: true, $paginate: false, ...filter } });
			commit('SET_STAFF_PERSONAS', results);
			commit('SET_LOADING_TEMPLATES', false);
			return results.data;
		},
		getPersonas: async ({ state, rootGetters, commit }, filter) => {
			const url = '/api/v3/personas';
			commit('SET_IS_LOADING_PERSONAS', true);
			const results = await feathersClient.service(url).find({
				query:
					{
						$role: rootGetters.currentUserRole,
						$userStatistics: true,
						  ...filter,
					},
			});
			if (results.length > 0) {
				const persona = results[0];
				const flattenNodeIds = (node, nodeIds = []) => {
					if (Array.isArray(node)) {
					  node.forEach((childNode) => flattenNodeIds(childNode, nodeIds));
					} else if (node && typeof node === 'object') {
					  if (node.nodeId) {
							nodeIds.push(node.nodeId);
					  }
					  if (node.groupingNodes && Array.isArray(node.groupingNodes)) {
							node.groupingNodes.forEach((childNode) => flattenNodeIds(childNode, nodeIds));
					  }
					}
					return nodeIds;
				  };
				  const editJobPersonaNodeIds = flattenNodeIds(state.shiftEditPersona);
				  const addIsSelectedField = (node) => {
					if (state.isEditJobPersona) {
					  node.isSelected = editJobPersonaNodeIds.includes(node.nodeId);
					} else {
					  node.isSelected = true;
					}
					// node.isSelected = true;
					if (node.groupingNodes && Array.isArray(node.groupingNodes)) {
					  node.groupingNodes.forEach(addIsSelectedField);
					}
				  };
				  if (state.isEditJobPersona) {
					// Copy userSkillSet from persona
					const userSkillSetCopy = { ...persona.userSkillSet };
					state.shiftEditPersona.userSkillSet = userSkillSetCopy;
					addIsSelectedField(state.shiftEditPersona);
					commit('SET_SELECTED_PERSONA', state.shiftEditPersona);
					commit('SET_CUSTOM_PERSONA', state.shiftEditPersona);
					commit('SET_IS_LOADING_PERSONAS', false);
					return state.shiftEditPersona;
				  }
				addIsSelectedField(persona);
				commit('SET_SELECTED_PERSONA', persona);
				commit('SET_CUSTOM_PERSONA', persona);
				commit('SET_IS_LOADING_PERSONAS', false);
				return persona;
			  }
			  commit('SET_IS_LOADING_PERSONAS', false);
		},
		searchCapability: async ({ rootGetters, commit }, filter) => {
			const url = '/api/v3/neo-search';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $removeIncompleteCapability: true, ...filter } });
			commit('SET_CAPABILITIES', results);
			return results;
		},
		createJob: async ({ rootGetters }, {data,query}) => {
			const url = '/api/v3/jobs';
			const results = await feathersClient.service(url).create(data, {
				query: {
					$role: rootGetters.currentUserRole,
					$ignoreWarning:query.$ignoreWarning || false,
				},
			});
			return results;
		},
		createPersona: async ({ rootGetters }, data) => {
			const url = '/api/v3/personas';
			const results = await feathersClient.service(url).create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		updatePersona: async ({ rootGetters }, data) => {
			const url = `/api/v3/personas`;
			const results = await feathersClient.service(url).patch(data.id, data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		updateJobPersona: async ({ rootGetters }, data) => {
			const url = `/api/v3/jobs`;
			const results = await feathersClient.service(url).patch(data.id, data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},

		getSavedPersonas: async ({ state, rootGetters, commit }, filter) => {
			const url = '/api/v3/personas';
			commit('SET_IS_LOADING_PERSONAS', true);
			const results = await feathersClient.service(url).find({
				query:
					{
						$role: rootGetters.currentUserRole,
						$userStatistics: true,
						  ...filter,
					},
			});
			if (results.length > 0) {
				const persona = results[0];
				const flattenNodeIds = (node, nodeIds = []) => {
					if (Array.isArray(node)) {
					  node.forEach((childNode) => flattenNodeIds(childNode, nodeIds));
					} else if (node && typeof node === 'object') {
					  if (node.nodeId) {
							nodeIds.push(node.nodeId);
					  }
					  if (node.groupingNodes && Array.isArray(node.groupingNodes)) {
							node.groupingNodes.forEach((childNode) => flattenNodeIds(childNode, nodeIds));
					  }
					}
					return nodeIds;
				  };
				  const editJobPersonaNodeIds = flattenNodeIds(state.shiftEditPersona);
				  const addIsSelectedField = (node) => {
					if (state.isEditJobPersona) {
					  node.isSelected = editJobPersonaNodeIds.includes(node.nodeId);
					} else {
					  node.isSelected = true;
					}
					if (node.groupingNodes && Array.isArray(node.groupingNodes)) {
					  node.groupingNodes.forEach(addIsSelectedField);
					}
				  };
				addIsSelectedField(persona);
				commit('SET_SELECTED_PERSONA', persona);
				commit('SET_CUSTOM_PERSONA', persona);
				commit('SET_IS_LOADING_PERSONAS', false);
				return persona;
			  }
			  commit('SET_IS_LOADING_PERSONAS', false);
		},
		getCalculatePersona: async ({ state, rootGetters, commit }, filter) => {
			const url = '/api/v3/personas';
			commit('SET_IS_LOADING_PERSONAS', true);
			const results = await feathersClient.service(url).find({
				query:
					{
						$role: rootGetters.currentUserRole,
						$userStatistics: true,
						  ...filter,
					},
			});
			commit('SET_IS_LOADING_PERSONAS', false);
			return results;
		},
		getPersonaStaffs: async ({ state, rootGetters, commit }, filter) => {
			const url = '/api/v3/personas';
			commit('SET_IS_LOADING_PERSONAS', true);
			const results = await feathersClient.service(url).find({
				query:
					{
						$role: rootGetters.currentUserRole,
						$userStatistics: true,
						  ...filter,
					},
			});
			if (results.length > 0) {
				const persona = results[0];
				commit('SET_PERSONA_STAFF', persona);
				commit('SET_IS_LOADING_PERSONAS', false);
				return persona;
			  }
			  commit('SET_IS_LOADING_PERSONAS', false);
		},
		getOptimaRejectedBookings: async ({ rootGetters }, filter) => {
			const url = '/api/v3/jobs'; // SHIFT-MANAGER
			const results = await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole,
					$managerBookingRejectedJobs: true,
					$skip: 0,
					$limit: 10,
					...filter,
					fields: ['applications', 'optimaBookingReference', 'careLocations', 'manager'],
				},
			});
			return results;
		},
	},
};
